import { Injectable } from "@angular/core";
import { ProductCollectionGroupsEnum } from "../../../../../shared/enums/product-collection-groups-enum";
import { ProductCollectionsEnum } from "../../../../../shared/enums/product-collections.enum";
import { SearchScopeEnum } from "../../../../../shared/enums/search-scope.enum";
import { DropdownOptionModel } from "../../../../../shared/models/components/form-controls/dropdown-option.model";
import { CollectionGroupModel } from "../../../../../shared/models/search/collection-groups/collection-group.model";
import { ProductScopeConfigModel } from "../../../../models/search-config/scopes/product-scope-config.model";
import { ContentSearchConfigService } from "../../../../services/content-search-config.service";

@Injectable({
    providedIn: "root"
})
export class ProductsFilterFormService {
    public constructor(
        private configService: ContentSearchConfigService
    ) {
    }

    private get DEFAULT_COLLECTION_GROUP(): ProductCollectionGroupsEnum {
        return ProductCollectionGroupsEnum.All;
    }

    private get DEFAULT_COLLECTION(): ProductCollectionsEnum {
        return ProductCollectionsEnum.All;
    }

    public getDefaultCollectionGroup(): ProductCollectionGroupsEnum {
        const config = this.configService.getConfigByScope<ProductScopeConfigModel>(SearchScopeEnum.Product);
        if (!config) {
            return this.DEFAULT_COLLECTION_GROUP;
        }
        return config.defaultCollectionGroup || this.DEFAULT_COLLECTION_GROUP;
    }

    public getDefaultCollection(): ProductCollectionsEnum {
        const config = this.configService.getConfigByScope<ProductScopeConfigModel>(SearchScopeEnum.Product);
        if (!config) {
            return this.DEFAULT_COLLECTION;
        }
        return config.defaultCollection || this.DEFAULT_COLLECTION;
    }

    public getSortingOptions(): Array<DropdownOptionModel> {
        const config = this.configService.getConfigByScope<ProductScopeConfigModel>(SearchScopeEnum.Product);
        if (!config) {
            return new Array<DropdownOptionModel>();
        }

        const options = config.sortingOptions.map(x => new DropdownOptionModel(x.title, x.value));
        return options;
    }

    public getDefaultSortingOption(searchText: string = null): string {
        const config = this.configService.getConfigByScope<ProductScopeConfigModel>(SearchScopeEnum.Product);
        if (!config) {
            return "";
        }

        let defaultValue = config.sortingOptions.find(x => x.isDefault);
        if (!defaultValue) {
            if (!!searchText) {
                defaultValue = config.sortingOptions.find(x => x.value === "BestMatch");
            } else {
                defaultValue = config.sortingOptions.find(x => x.value === "DateCreated");
            }
        }

        return defaultValue ? defaultValue.value : "";
    }

    public isSingleCollectionGroup(collectionGroupId: ProductCollectionGroupsEnum): boolean {
       const targetCollectionGroup = this.getCollectionGroupById(collectionGroupId);
       const isSingleCollectionGroup = !!targetCollectionGroup ? targetCollectionGroup.collections.length === 1 : false /*All*/;

       return isSingleCollectionGroup;
    }

    public getCollectionForSingleCollectionGroup(collectionGroupId: ProductCollectionGroupsEnum): ProductCollectionsEnum {
        const targetCollectionGroup = this.getCollectionGroupById(collectionGroupId);
        const collectionId = targetCollectionGroup.collections[0].id;

        return collectionId;
    }

    private getCollectionGroupById(collectionGroupId: ProductCollectionGroupsEnum): CollectionGroupModel {
        const config = this.configService.getConfigByScope<ProductScopeConfigModel>(SearchScopeEnum.Product);
        const collectionGroups = config.collectionGroups.entries;
        const targetCollectionGroup = collectionGroups.find(x => x.id === collectionGroupId);

        return targetCollectionGroup;
    }
}
